export class PrescriptionsModel {
  constructor(
    public prescriptionId: string,
    public prescriptionName: string,
    public prescriptionCategoryId: string,
    public prescriptionCategoryName: string,
    public isWeekType: boolean,
    public quantity: number,
    public centreId: string,
    public centrePrescriptionId: string,
    public id: string
  ) { }
}



// WEBPACK FOOTER //
// D:/TMB/sr-git-v1/TMB.UI/src/app/models/consultation-process/prescription-selection.model.ts